import { ApolloProvider } from "@apollo/client";
import {
  PTVNUserProvider,
  PTVNUserProviderConfig
} from "@ptvn-react/authentication";
import { Store } from "@reduxjs/toolkit";
import { ConnectedRouter } from "connected-react-router";
import environment from "environment";
import React from "react";
import { positions, transitions } from "react-alert";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import { GatewayGraphQLClient } from "./app/api/GatewayGraphQLClient";
import App from "./app/App";
import { Compose, withProvider } from "./app/components/compose/index";
import { ModalStackProvider } from "./app/components/modal/ModalStackProvider";
import { SmartAlertProvider } from "./app/components/smartAlert/SmartAlert";
import { Indicator, IndicatorProvider } from "./app/provider/IndicatorProvider";
import { configuredStore, history, RootState } from "./app/store/rootStore";
import APIConstant from "./app/utils/constants/APIConstant";
import PageRoute from "./app/utils/constants/PageRoute";
// import "./assets/css/style.css";
import "./assets/css/intelligence_style.css";
import "./i18n/i18n";
import "./index.scss";

const initialState: Partial<RootState> = {};
const store: Store<RootState> = configuredStore(initialState);
const persistor = persistStore(store);

const alertOptions = {
  position: positions.BOTTOM_CENTER,
  timeout: 8000,
  transition: transitions.FADE,
  offset: "0 auto 24px",
  containerStyle: {
    zIndex: 10000000000,
  } as React.CSSProperties,
};

const PTVNUserConfig: PTVNUserProviderConfig = {
  redirectURL: APIConstant.redirectURL,
  clientID: environment.clientID,
  unauthorizedDefaultPage: PageRoute.DEFAULT,
  accountLoginPageURL:
    APIConstant.authenticationCenterService.accountLoginPageURL,
  accountGetAccessTokenURL:
    APIConstant.authenticationCenterService.accountGetAccessTokenURL,
  accountRealmInformationURL:
    APIConstant.authenticationCenterService.accountRealmInformationURL,
  accountRenewAccessTokenURL:
    APIConstant.authenticationCenterService.accountRenewAccessTokenURL,
};

const msClaritySetup = () => {
  const scripClarity: HTMLScriptElement = document.createElement("script");
  scripClarity.type = "text/javascript";
  scripClarity.async = true;
  scripClarity.innerHTML = `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "${environment.trackerId.msClarity}");`;
  document.head.appendChild(scripClarity);
};

msClaritySetup();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<>loading...</>} persistor={persistor}>
      <Compose
        components={[
          withProvider(PTVNUserProvider, {
            config: PTVNUserConfig,
          }),
          withProvider(Provider, { store: store }),
          withProvider(ConnectedRouter, { history }),
          withProvider(SmartAlertProvider, alertOptions),
          withProvider(ModalStackProvider),
          withProvider(IndicatorProvider),
          withProvider(ApolloProvider, { client: GatewayGraphQLClient }),
        ]}
      >
        <Indicator />
        <App />
      </Compose>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
